import type { CapacitorConfig } from "@capacitor/cli";

// Only check for process.env during build time, not runtime
const serverUrl =
	typeof process !== "undefined" && process.env?.CAP_SERVER_URL
		? process.env.CAP_SERVER_URL
		: undefined;

// Disable CapacitorHttp in development to avoid issues with ngrok/localhost
// In production, enable it for better native performance
const isDevelopment =
	typeof process !== "undefined" && process.env?.NODE_ENV === "development";

const config: CapacitorConfig = {
	appId: "co.eraborn.app",
	appName: "Era",
	webDir: "dist",
	server: {
		...(serverUrl ? { url: serverUrl } : {}),
		androidScheme: "https",
		cleartext: false,
		// Allow navigation to Auth0, Statsig, Sentry, and our domains
		allowNavigation: [
			"*.auth0.com",
			"*.eraborn.co",
			"api-prd.eraborn.co",
			"localhost",
			"*.ngrok-free.dev",
			"*.ngrok.app",
			"*.ngrok.io",
			"*.zrok.io",
			"*.share.zrok.io",
			"amirweb.share.zrok.io",
			"amirapi.share.zrok.io",
			"*.statsig.com",
			"prodregistryv2.org",
			"*.sentry.io",
			"*.ingest.sentry.io",
		],
	},
	plugins: {
		Haptics: {
			// Enable haptic feedback
		},
		CapacitorHttp: {
			enabled: !isDevelopment, // Disable in favor of standard web HTTP
		},
	},
	ios: {
		// iOS-specific deep link configuration
		scheme: "co.eraborn.app",
	},
	android: {
		// Android-specific deep link configuration
		allowMixedContent: true,
	},
	// Deep link configuration for Auth0 callbacks
	cordova: {
		preferences: {
			scheme: "co.eraborn.app",
			hostname: "localhost",
		},
	},
};

export default config;
